import axios from "axios";
import { TRONSCAN_API_ADDRESS } from "../../constants/config";
import { CONTRACT_ADDRESS } from "../../constants/tokens";

export class SearchOptionsService {
  public fetchOptions = async (value) => {
    try {
      if (value.length > 2) {
        const queryString = `?term=${value}`;
        const { data } = await axios.get(
          `${TRONSCAN_API_ADDRESS}/search${queryString}`
        );
        const results = data
          .filter((item) => item.desc !== "Token-TRC10")
          .filter((item) => {
            switch (item.desc) {
              case "Token-TRC20": {
                if (
                  item.value ===
                    "Centric CASH(CNS) TMJWuBDvwvcm6QUWXDaC6GqTyq3FgEmWEt" ||
                  item.value ===
                    "Centric RISE(CNR) TYLrbh1pVcx95bop33XQ1iYdh7r3ogEQ8Q"
                ) {
                  return true;
                } else {
                  return false;
                }
              }
              case "Contract": {
                if (
                  item.value === CONTRACT_ADDRESS.rise ||
                  item.value === CONTRACT_ADDRESS.cash
                ) {
                  return true;
                } else {
                  return false;
                }
              }
              default:
                return item;
            }
          })
          .map((item) => {
            switch (item.desc) {
              case "Token-TRC20":
                return {
                  desc: "Token",
                  value: item.value,
                };
              case "Contract":
              case "TxHash":
              case "Address":
                return {
                  desc: item.desc,
                  value: item.value.toString(),
                };
              default:
                return {
                  desc: item.desc,
                  value: item.value.toString(),
                };
            }
          });
        return results;
      }
    } catch (e) {
      console.log(e);
      if (e.message) {
        throw e;
      }
      throw new Error("Error connecting to account service");
    }
  };
}
